import { Button, Checkbox, Code, NumberInput, SimpleGrid, TextInput } from '@mantine/core';
import { useForm, yupResolver } from '@mantine/form';
import { useState } from 'react';

import usePassword from './usePassword';

import { object, string } from "yup";
const userSchema = object().shape({
    current_password: string()
        .required("current password is required")
        .min(3, "current password must be at least 3 characters"),

    password: string()
        .required("password is required")
        .min(3, "password must be at least 3 characters"),

    confirm_password: string()
        .required("confirm password is required")

});

function Demo() {
    const {
        createMutation
    } = usePassword()

    const [submittedValues] = useState('');

    const form = useForm({
        initialValues: {
            name: "",
        },
        validate: yupResolver(userSchema)
    });
    const handleCreate = form.onSubmit(async (values) => {

        const formData = new FormData();
        formData.append("current_password", values?.current_password);
        formData.append("password", values?.password);
        formData.append("confirm_password", values?.confirm_password);
        createMutation.mutate(formData)
    })

    return (
        <>
            <h1>Change Password</h1>

            <SimpleGrid cols={2}>

                <TextInput
                    label="Current Password"
                    placeholder="Enter Current Password"
                    key={form.key('current_password')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('current_password')}
                />
                <TextInput
                    label="Password"
                    placeholder="Enter Password"
                    key={form.key('password')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('password')}
                />

                <TextInput
                    label="Confirm Password"
                    placeholder="Enter Confirm Password"
                    key={form.key('confirm_password')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('confirm_password')}
                />


            </SimpleGrid>
            <br></br>
            <div />

            <Button type="submit" mt="md" onClick={handleCreate} loading={createMutation?.isPending}>
                Submit
            </Button>
            {submittedValues && (
                <Code block mt="md">
                    {submittedValues}
                </Code>
            )}
        </>
    );
}



export default Demo;
